export const colors = [
  {
    title: "None",
    key: 4278190080,
    hex: undefined,
  },
  {
    title: "Red",
    key: 255,
    hex: "#FF0000",
  },
  {
    title: "orange",
    key: 42495,
    hex: "#FFA500",
  },
  {
    title: "yellow",
    key: 65535,
    hex: "#FFFF00",
  },
  {
    title: "Torquise",
    key: 13688896,
    hex: "#40E0D0",
  },
  {
    title: "Black",
    key: 0,
    hex: "#000000",
  },
  {
    title: "olive",
    key: 32896,
    hex: "#808000",
  },
  {
    title: "chocolate",
    key: 1993170,
    hex: "#D2691E",
  },
  {
    title: "blue",
    key: 16711680,
    hex: "#0000FF",
  },
];
